import { render, staticRenderFns } from "./TabelaProdutoMonitoria.vue?vue&type=template&id=2f952b4d&scoped=true&"
import script from "./TabelaProdutoMonitoria.vue?vue&type=script&lang=js&"
export * from "./TabelaProdutoMonitoria.vue?vue&type=script&lang=js&"
import style0 from "./TabelaProdutoMonitoria.vue?vue&type=style&index=0&id=2f952b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f952b4d",
  null
  
)

export default component.exports